/**
 * Pemecah klausa untuk kalimat panjang (#59 latensi suara): kalimat yang belum
 * selesai tapi sudah melewati `CLAUSE_SPLIT_CHARS` dikirim lebih dulu sampai
 * koma/titik koma aman, supaya GPT-Live bisa mulai bicara lebih cepat.
 */

/** Panjang kalimat (karakter) sebelum boleh dipotong di koma/titik koma. */
export const CLAUSE_SPLIT_CHARS = 80;

const CLAUSE_MARKS = new Set([",", ";"]);

/**
 * Indeks akhir (eksklusif) klausa pertama yang panjangnya ≥ `minLength`, atau -1.
 * Aman: tanda harus diikuti spasi, jadi "1.234,5", "2,5 juta", dan "Rp1.250,00"
 * tidak pernah terpotong; tanda di ujung buffer menunggu karakter berikutnya.
 */
export function findClauseBreak(text: string, minLength: number): number {
	for (let i = Math.max(0, minLength - 1); i < text.length; i++) {
		if (!CLAUSE_MARKS.has(text[i] ?? "")) continue;
		const after = text[i + 1];
		if (after === undefined) return -1;
		if (/\s/.test(after)) return i + 1;
	}
	return -1;
}
